import React from "react";
import {observer} from "mobx-react";
import Handle from "./SortableHandle";
import {FieldContext} from "@morningtrain/react-fields";
import { useForm, useIndex } from "@morningtrain/react-resources";

function RepeaterSegmentHead(props) {

    const field = React.useContext(FieldContext);
    const form = useForm()
    const index = useIndex();

    const onClick = () => {

        if(field.displayOnly === true) {
            return;
        }

    };

    const removeItem = (e) => {


        e.stopPropagation();

        if (confirm(field.removeConfirmMessage)) {

            let values = [...field.value];

            if (values[index]) {
                values[index] = null;
            }

            field.value.replace(values.filter(v => v));

            if(form && typeof form.setAsChanged === 'function') {
                form.setAsChanged();
            }
        }

    }

    return (
        <div className={'repeater-field-entry-header'} onClick={onClick}>
            <div className={'repeater-field-entry-header-title'}>
                {field.itemHeader}
            </div>
            <div className={'repeater-field-entry-header-actions'}>
                {field.extraHeaderActions}
                {((field.draggable === true && field.displayOnly === false) ? <Handle/> : null)}
                {(field.displayOnly === true)?null:(
                    <button type={'button'} className={field.buttonClass} onClick={e => removeItem(e, index)}>{field.removeLabel}</button>
                )}
            </div>
        </div>
    );
}

export default observer(RepeaterSegmentHead);
